import React, { memo } from "react";
import { useT } from "@al/next/al-ex";
import { WebpImage, Button } from "@al/akui-mobile";

import errorImage from "./images/error.png";
import styles from "./styles.scss";

type Props = {
  onRefresh: () => void;
};

const NetworkError: React.FC<Props> = (props) => {
  const t = useT();

  return (
    <div className={styles.page}>
      <div className={styles.icon_box}>
        <WebpImage source={errorImage} className={styles.icon} />
      </div>
      <div className={styles.tips}>{t("请求失败，请稍后重试")}</div>
      <Button className={styles.btn} color="primary" fill="outline" onClick={props.onRefresh}>
        {t("刷新")}
      </Button>
    </div>
  );
};

export default memo(NetworkError);
